import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeExtension',
  standalone: true,
})
export class RemoveExtensionPipe implements PipeTransform {
  transform(fileName: string): string {
    if (!fileName) return '';
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
  }
}
